import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import StudentTestimonialForm from "../Layout/StudentTestimonialForm";
import { StudentTestimonialFormValues } from "src/models/StudentTestimonial.model";
import { useAddTestimonialMutation } from "src/services/StudentTestimonialServices";
type Props = {
  onClose: () => void;
};

const AddStudentTestimonialFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  const [addTestimonial] = useAddTestimonialMutation();

  // Form Initial Values
  const initialValues: StudentTestimonialFormValues = {
    image: "",
    video: "",
    name: "",
    text: "",
    currentCompany: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required("Please enter student name"),
    text: string().required("Please enter testimonial"),
    currentCompany: string().required("Please enter current company"),
  });

  // Handle Submit
  const handleSubmit = (
    values: StudentTestimonialFormValues,
    { setSubmitting, resetForm }: FormikHelpers<StudentTestimonialFormValues>
  ) => {
    const formatedValue = {
      image: values.image,
      video: values.video,
      name: values.name,
      text: values.text,
      currentCompany: values.currentCompany,
    };

    addTestimonial(formatedValue).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          if (!saveNextChecked) {
            resetForm();
            onClose();
          }
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="lg" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            <StudentTestimonialForm
              formikProps={formikProps}
              onClose={onClose}
              formType="Add"
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddStudentTestimonialFormWrapper;
